<template>
  <div class="page-popup">
    <div v-show="gameModalOpen && isActive" class="popup-wrap" :class="{ active: isActive }">
      <div class="popup-box">
        <div class="popup-page">
          <!--eslint-disable-next-line -->
          <p class="h5 nl2br" v-html="displayText" />
          <div v-if="gameModalButton" class="modal-footer">
            <span class="modal-button" @click="hideGame">
              {{ $t('Bao.enter') }}
            </span>
          </div>
        </div>
        <a v-if="hideModal" class="popup-close" @click="hideModel" />
      </div>
    </div>
  </div>
</template>

<script>
import { isCrossDay } from '@/utils/tool'

export default {
  name: 'PerformanceModal',
  props: {
    isActive: Boolean,
    limitText: {
      type: String,
      default: () => ('')
    }
  },
  data() {
    return {
      showPopup: false
    }
  },
  computed: {
    gameModalOpen() {
      // By default, return true and open game modal once a day
      let openModal = true
      // If limitText is not truthy, check the day condition
      if (!this.limitText) {
        const currentTimeStamp = Math.floor(Date.now() / 1000)
        const storedTimeStamp = localStorage.getItem('lastPopupTimeStamp')
        if (storedTimeStamp && !isCrossDay(currentTimeStamp, this.$store.state.app.lastPopupTimeStamp)) {
          openModal = false
        }
      }
      return openModal
    },
    gameModalButton() {
      return !this.limitText
    },
    hideModal() {
      return this.limitText
    },
    displayText() {
      return this.limitText || this.$store.state.brand.permissionInfo.bonus_wallet_rule
    }
  },
  watch: {
    '$store.state.app.lastPopupTimeStamp'(newVal) {
      if (newVal) {
        this.openGameModal()
      }
    },
    '$store.state.app.isFirstGameLaunch'(newVal, old) {
      if (newVal !== old) {
        this.openGameModal()
      }
    }
  },

  created() {
    this.updateLastPopupTimeStamp()
  },
  methods: {

    hideModel() {
      this.$emit('hideModel')
    },
    hideGame() {
      this.$store.commit('SET_MODAL_ACTIVE', false)
      const currentTimeStamp = Math.floor(Date.now() / 1000)
      localStorage.setItem('lastPopupTimeStamp', currentTimeStamp.toString())
      this.$store.commit('SET_LAST_POPUP_TIMESTAMP', currentTimeStamp)
    },
    updateLastPopupTimeStamp() {
      const storedTimeStamp = localStorage.getItem('lastPopupTimeStamp')
      if (storedTimeStamp) {
        this.SET_LAST_POPUP_TIMESTAMP(parseInt(storedTimeStamp, 10))
      }
    },
    openGameModal() {
      this.$store.commit('SET_GAME_URL', this.$store.state.app.tempGameUrl)
    }
  }
}
</script>

<style scoped>
.nl2br {
  white-space: pre-line;
  line-height: 1.2;
}
.modal-footer {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.modal-button {
  float: right;
  white-space: initial;
  padding: 10px 20px;
  border-radius: 5px;
  color: #978564;
  background: transparent;
  border: 1px solid #978564;
  transition: background-color 0.3s ease;
}

.modal-button:hover {
  background: #b1a781;
  border: 1px solid #b1a781;
  color: #fff;
}
@media (max-width: 600px) {
  .nl2br {
    font-size: 0.9em;
  }
  .modal-button {
    font-size: 1em;
  }
}
</style>
